/* Temporary article selection; only loaded by column-prototype. */
(() => {
  const profile = new URLSearchParams(location.search).get('column') === 'oil-milk' ? 'oil-milk' : 'autumn';
  document.querySelectorAll('[data-column-profile]').forEach(article => {
    article.hidden = article.dataset.columnProfile !== profile;
  });
})();
